import {ChatRead, ChatReadWRefs, ChatListItem, ChatSearchResult} from "../schemas/chat";
import {apiFetch} from "./client";

export async function createChat(groupId: string, userId: string): Promise<ChatReadWRefs> {
    return apiFetch<ChatReadWRefs>("/chats/create_chat", {
        params: {group_id: groupId, user_id: userId},
    });
}

export async function getChat(chatId: string): Promise<ChatReadWRefs> {
    return apiFetch<ChatReadWRefs>("/chats/get_chat", {
        params: {chat_id: chatId},
    });
}

export async function getChatsForGroup(groupId: string): Promise<ChatListItem[]> {
    return apiFetch<ChatListItem[]>("/chats/get_chats_for_group", {
        params: {group_id: groupId},
    });
}

export async function searchChats(groupId: string, query: string, limit = 20): Promise<ChatSearchResult[]> {
    return apiFetch<ChatSearchResult[]>("/chats/search_chats", {
        params: {group_id: groupId, q: query, limit},
    });
}

export async function updateChatTitle(chatId: string, title: string): Promise<ChatRead> {
    return apiFetch<ChatRead>("/chats/update_chat_title", {
        method: "PUT",
        body: {chat_id: chatId, title},
    });
}

export interface DeleteChatResult {
    deleted: boolean;
    chat_id: string;
    deleted_document_requests: number;
    deleted_references: number;
}

export async function deleteChat(chatId: string): Promise<DeleteChatResult> {
    return apiFetch<DeleteChatResult>("/chats/delete_chat", {
        method: "DELETE",
        params: {chat_id: chatId},
    });
}
